import routerMap from './router.map'
import {parseRoutes} from '@/utils/routerUtil'

/**
 * 菜单对应的所有功能相应的路由配置
 * ebase-menu也会用这个数据生成demo菜单
 * @type {({router: string}|{router: string}|{router: string, children: [string, string, string, string, string]}|{router: string, children: [string, string, string]}|{router: string, children: [string, string]})[]}
 */
const menuRoutesConfig = [
    // {
    // 	router:'demo',
    // 	children:["/demo/normalList"]
    // },
    // {
    //   router: 'answer',
    //   name: '传播内容',
    //   children: [
    //     "/answer/commonAnswer",
    //     "/answer/commonSpeech",
    //     "/answer/commonFile",
    //     "/answer/commonKeyWords",
    //   ]
    // },
    // {
    //   router: 'market',
    //   name: '传播内容',
    //   children: [
    //     "/market/articleMarket",
    //     "/market/videoMarket",
    //     "/market/posterManage",
    //     "/market/activeDZP",
    //     "/market/activeGGL",
    //     "/market/activeXYFK",
    //   ]
    // },
    // {
    // 	router: 'comm',
    // 	children: [
    // 		"/comm/menuManage",
    // 		"/comm/roleManage",
    // 		"/comm/commBaseCodeManage",
    // 		"/comm/commonAnswer",
    // 	]
    // },
    // {
    // 	router: 'clue',
    // 	children: [
    // 		"/clue/clueManage",
    // 		"/clue/clueReportManage",
    // 	]
    // },
    // {
    //   router: 'operate',
    //   children: [
    //     // "/operate/AutoReplySetUp",
    //     // "/operate/BulkAssistant",
    //     // "/operate/groupWelcomeResources",
    //     // "/operate/MassSendCustomer",
    //     // "/operate/MassSendCircle",
    //       "/operate/fission",
    //       "/operate/fissionStatistics",
    //   ]
    // },
    // {
    //     router: 'workflow',
    //     children: [
    //         "/workflow/workflow",
    //         "/workflow/modelManage",
    //         "/workflow/workflowManage",
    //         "/workflow/doingWorkflow",
    //         "/workflow/workflowHistory",
    //     ]
    // },
    // {
    //     router: 'client',
    //     children: [
    //         "/client/clientServer",
    //         // "/client/labelManage",
    //         // "/client/clientFollowUp",
    //         // "/client/clientTag",
    //         // "/client/customer",
    //         "/client/clientInherit",
    //         "/client/clientInheritRecord"
    //     ]
    // },
    // {
    //     router: 'report',
    //     children: [admin
    //         // "/report/customerReport",
    //         // "/report/clueReport",
    //         // "/report/clueFailReport",
    //         "/report/oldclueFailReport",
    //         // "/report/custStructureReport",
    //         // "/report/bigCustClueReport",
    //         // "/report/custIndustryReport",
    //         // "/report/custSourceReport",
    //         // "/report/oldcustSourceReport",
    //         // "/report/custKnownWayReport",
    //         // "/report/oldcustKnownWayReport",
    //         // "/report/custFollowWithReport",
    //         // "/report/oldcustFollowWithReport",
    //         // //"/report/activityReport",
    //         // "/report/activityListReport",
    //         // "/report/activityEffectReport",
    //     ]
    // },
    // {
    //     router: 'activityManage',
    //     children: [
    //         "/activityManage/activityList",
    //         "/activityManage/activityAccount",
    //         "/activityManage/activityType",
    //     ]
    // },
    // qf28
    {
        router: 'publicizeMaterialManagement',
        children: [
                // "/publicizeMaterialManagement/publicizeMaterialMaintenance",
                // "/publicizeMaterialManagement/advertiseMaterialRequisition",
                "/publicizeMaterialManagement/materialApplyQuota",
                "/publicizeMaterialManagement/applyOrder",
                "/publicizeMaterialManagement/applyOrderDetail",
                "/publicizeMaterialManagement/deliveryDetail",
                 "/publicizeMaterialManagement/applyOrderApprove",
                //  "/publicizeMaterialManagement/publicizeMaterialInWarehouse",
                //  "/publicizeMaterialManagement/publicizeMaterialApplicationDetails",
                //  "/publicizeMaterialManagement/publicizeMaterialOutWarehouse",

                 "/publicizeMaterialManagement/addMaterial",
                 "/publicizeMaterialManagement/editMaterial",
                 "/publicizeMaterialManagement/detailMaterial",
                 "/publicizeMaterialManagement/addInWarehouse",
                 "/publicizeMaterialManagement/addOutWarehouse",
                //  "/publicizeMaterialManagement/address",

                // 尝试修改 4.6号
                 "/publicizeMaterialManagement/reviewInfo",
                 "/publicizeMaterialManagement/campaignInfo",
                 "/publicizeMaterialManagement/itemRequisition",
            ]
     },
    {
        router: 'bigCustomer',
        children: [
            "/bigCustomer/visitDetail",
        ]
    },
     {
        router: 'terminalActivity',
        children: [
            // "/terminalActivity/planDelivery",
            "/terminalActivity/addActivity",
            "/terminalActivity/editActivity",
            "/terminalActivity/detailsActivity",
            // "/terminalActivity/applyActivityList",
            "/terminalActivity/signActivity",
            // "/terminalActivity/signIndex",
            "/terminalActivity/signDetails",
            "/terminalActivity/editSignActivity",
            "/terminalActivity/editSignActivityDate",
            // "/terminalActivity/activityReimbursement",
            "/terminalActivity/detailedReimbursement",
            "/terminalActivity/executeReimbursement",
            // "/terminalActivity/dealerAmountMList",
            // "/terminalActivity/delayApproveList",
            // "/terminalActivity/actCustomerList",
            // 在经销商费用维护详情后面
            "/terminalActivity/dealerAmountMDetail",
            // 在活动扫码集客后面
            "/terminalActivity/actCustomerDetail",
        ]
     },
     {
        router: 'comm',
        children: [
            // '/comm/bicvalList',
            '/comm/bicValDetail'
        ]
     }
]

// 异步路由配置
const routesConfig = [
    'login',
    'root',
    {
        router: 'exp404',
        path: '*',
        name: '404'
    },
    {
        router: 'exp403',
        path: '/403',
        name: '403'
    },
].concat(menuRoutesConfig)  // 要在这里定义所有的路由，否则会在localStorage和token失效后，找不到当前页面，从而指向404

const options = {
    routes: parseRoutes(routesConfig, routerMap),
    menuRoutesConfig
}

export default options
